import cn from 'classnames'
import { DigitalExamQuestion as DigitalExamQuestionType } from './digitalExamPage.types'

export interface DigitalExamQuestionNavProps {
  questions: DigitalExamQuestionType[]
  answers: Record<string, string>
  currentIndex: number
  navigationLabel: string
  onQuestionSelect: (index: number) => void
}

export const DigitalExamQuestionNav = ({
  questions,
  answers,
  currentIndex,
  navigationLabel,
  onQuestionSelect,
}: DigitalExamQuestionNavProps) => {
  return (
    <nav className='digital-exam-page__nav' aria-label={navigationLabel}>
      <ol className='digital-exam-page__nav-list'>
        {questions.map((question, index) => {
          const isAnswered = Boolean(answers[question.id])
          const isCurrent = index === currentIndex
          return (
            <li key={question.id}>
              <button
                type='button'
                onClick={() => onQuestionSelect(index)}
                aria-current={isCurrent ? 'step' : undefined}
                aria-label={`${navigationLabel} ${index + 1}`}
                className={cn('digital-exam-page__nav-item', {
                  'digital-exam-page__nav-item--current': isCurrent,
                  'digital-exam-page__nav-item--answered': isAnswered,
                })}
              >
                {index + 1}
              </button>
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
